import { useBranding } from "../context/BrandingContext";

export default function Brand({ compact = false }) {
  const { branding } = useBranding();
  return <div className="flex items-center gap-3">{branding.logoUrl && <img src={branding.logoUrl} alt={branding.name} className="h-11 w-11 object-contain" />}{!compact && <div><div className="brand-name text-xl font-black uppercase tracking-[-.04em]">{branding.name}</div><div className="brand-tagline text-[9px] font-bold uppercase tracking-[.32em]">{branding.tagline}</div></div>}</div>;
}
